// extracted by mini-css-extract-plugin
export default {"CurrentPage":"CurrentPage_CurrentPage__+RUuG"};